module.exports = __webpack_public_path__ + "img/ltkkids-4x.55c1cbe.jpg";